/*
 * @Author: wzh
 * @Date: 2023-05-31 09:23:57
 * @LastEditTime: 2023-05-31 09:23:58
 * @Description: 社交账号绑定 js
 */
import SocialLogin from "./social.vue";

export { SocialLogin };
